import { c as _c } from "react/compiler-runtime";
import { FormUrlPathInput } from 'shared/components';
import useUser from 'shared/hooks/use-user';
import { getPublicPath } from 'shared/utils/locale/get-locale-for-link';
interface AffiliatePromotionLinkProps {
  affiliateId?: string;
}
const AffiliateDashboardPromotionLink = t0 => {
  const $ = _c(6);
  const {
    affiliateId
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] !== affiliateId || $[1] !== user?.dashboardLocale) {
    t1 = affiliateId ? `${getPublicPath(user?.dashboardLocale).slice(1)}?sa=${affiliateId}` : "";
    $[0] = affiliateId;
    $[1] = user?.dashboardLocale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const promotionPath = t1;
  const t2 = !affiliateId;
  let t3;
  if ($[3] !== promotionPath || $[4] !== t2) {
    t3 = <FormUrlPathInput disabled={true} domainName={process.env.NEXT_PUBLIC_SIO_HOST_NAME} isPreFetching={t2} value={promotionPath} />;
    $[3] = promotionPath;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default AffiliateDashboardPromotionLink;